import { useParams } from 'react-router-dom';
import { findProjectBySlug, findBlogsBySlugs } from '../utils';
import ProjectTemplate from '../components/ProjectTemplate';

const ProjectDetailsPage = () => {
    const { slug } = useParams();
    const project = findProjectBySlug(slug);

    if (!project) {
        return (
            <main className="project-not-found">
                <h1>Project not found</h1>
                <p>The project you are looking for does not exist.</p>
            </main>
        );
    }

    const relatedPosts = findBlogsBySlugs(project.relatedPostSlugs);

    return <ProjectTemplate project={project} relatedPosts={relatedPosts} />;
};

export default ProjectDetailsPage;